module.exports = __webpack_public_path__ + "img/icon-s-ocean.df603114.png";